<template>
  <abnormalProgress title="异常信息"/>
</template>

<script>
import abnormalProgress from './abnormalProgress';

export default {
  name: 'homeAbnormals',
  components: {
    abnormalProgress
  }
};
</script>

<style scoped lang="scss">
</style>
